// axios 默认配置，包含基础路径等信息
export default {
  method: 'get',
  // URL 前缀
  baseURL: process.env.VUE_APP_MODEL_BASE_URL,
  // baseURL: 'https://cqgxq.matchn.cn/cqgxq-api',
  // baseURL: 'http://192.168.2.6:90',
  // 图片上传地址
  baseImgURL: process.env.VUE_APP_MODEL_BASE_URL + '/match/file/upload',

  // header信息
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  // 参数
  data: {},
  // 超时时间
  timeout: 10000,
  // 携带凭证
  withCredentials: true,
  // 返回数据类型
  responseType: 'json',
}



// WEBPACK FOOTER //
// ./src/comm/http/config.js